import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useReactRouter from 'use-react-router';
import { RouteComponentProps } from 'react-router';

import ModalPlanExpired from '../../components/ModalPlanExpired/ModalPlanExpired';
import { selectIsLogin } from '../../reducer/login.selectors';
import { selectExpirePlaneDateTime } from '../../reducer/user.selectors';
import { checkIfExistInsideArray, isPlanExpired } from '../../utils/utils';
import { LOGOUT_REQUEST, LOGOUT_MODAL_HIDE } from '../../actions/login.action';

const notShowModalUrlList = ['/invoice/'];

const ModalPlanExpiredContainer = React.memo(() => {
  const isLogged = useSelector(selectIsLogin);
  const expirePlaneDateTime = useSelector(selectExpirePlaneDateTime);
  const dispatch = useDispatch();
  const isExpired = isPlanExpired(expirePlaneDateTime);
  const [isShowed, setIsShowed] = useState<boolean>(false);
  const { location }: RouteComponentProps = useReactRouter();
  const handleHideHandler = useCallback(
    (logout?: boolean) => {
      if (logout) {
        setIsShowed(false);
        dispatch(LOGOUT_REQUEST());
        dispatch(LOGOUT_MODAL_HIDE());
      } else {
        setIsShowed(true);
      }
    },
    [dispatch, setIsShowed]
  );

  useEffect(() => {
    if (isExpired && isLogged) {
      setIsShowed(false);
    }
  }, [isLogged, isExpired, setIsShowed]);

  const isUrlAvaibleforModalShowing = useMemo(() => !checkIfExistInsideArray(notShowModalUrlList, location.pathname), [
    location.pathname
  ]);

  const showModalCondition = useMemo(() => isExpired && !isShowed && isUrlAvaibleforModalShowing, [
    isExpired,
    isShowed,
    isUrlAvaibleforModalShowing
  ]);

  if (!isLogged) {
    return null;
  }

  return (
    <>
      <ModalPlanExpired show={showModalCondition} onHide={handleHideHandler} />
    </>
  );
});

export default ModalPlanExpiredContainer;
